import { render, staticRenderFns } from "./CChartSalesPerClient.vue?vue&type=template&id=1c8463c4"
import script from "./CChartSalesPerClient.vue?vue&type=script&lang=js"
export * from "./CChartSalesPerClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports